<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn">
    <div>
      <span v-show="false">{{ reactivity }}</span>
      <!-- loading component -->
      <Loading />
      <b-card style="border: 0" class="mt-0 mb-0">
        <b-card
          v-if="
            proposal.status == 'نیاز به تکمیل / اصلاح' && proposal.adminMessage
          "
          header-bg-variant="danger"
          header-text-variant="white"
          header="اصلاحات مورد نیاز"
          style="border: 0"
          class="shadow p-3 mb-5 bg-white rounded mt-0"
          >{{ errorMessage }}</b-card
        >
        <b-tabs class="mb-3" pills vertical v-model="tabIndex">
          <div class="d-flex justify-content-center mt-3">
            <!-- NOTE (b-previousTab) to go to the previous tab -->
            <b-button
              v-if="tabIndex != 0"
              class="mx-1"
              variant="light"
              @click="changePage('back')"
              >مرحله قبل</b-button
            >
            <!-- NOTE (b-nextTab) to go to the next tab -->
            <b-button
              v-if="tabIndex != 7"
              class="mx-1"
              variant="primary"
              @click="changePage('next')"
              >مرحله بعد</b-button
            >
          </div>
          <b-tab :title="'حمایت‌های پیشین از دوره‌'" active>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">حمایت‌های پیشین</h4>
              </template>
              <b-card
                header-bg-variant="#8341a4"
                header-text-variant="white"
                header="پژوهشگر مورد نظر"
                style="border: 0"
                class="shadow p-3 mb-5 bg-white rounded mt-0"
              >
                <b-form-group>
                  <Select2
                    class="myselect2"
                    v-model="proposal.researcherId"
                    :options="researchers"
                    :settings="{ width: '100%' }"
                    @change="showAcount()"
                  ></Select2>
                </b-form-group>
              </b-card>
              <b-form-group>
                <div class="d-flex" dir="ltr">
                  <label
                    for="switch_1"
                    :class="
                      proposal.initialObligation
                        ? 'ml-3 mb-0 done'
                        : 'ml-3 mb-0 required'
                    "
                  >
                    اینجانب تعهد می کنم با مطالعه و آگاهی از
                    <b-button
                      id="downLoad"
                      title="دانلود تعهدات"
                      variant="link"
                      href="/researcher/rules/meeting/شیوه نامه نشست های تخصصی.pdf"
                    >
                      <b-tooltip
                        placement="bottomleft"
                        target="downLoad"
                        triggers="hover"
                        variant="info"
                        >دانلود شیوه‌نامه</b-tooltip
                      >شیوه‌نامه حمایت از نشست‌های تخصصی ستاد توسعه زیست فناوری </b-button
                    >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست در
                    سامانه اقدام می نمایم
                  </label>
                  <b-form-checkbox
                    id="switch_1"
                    v-model="proposal.initialObligation"
                  ></b-form-checkbox>
                </div>
              </b-form-group>
              <hr />
              <h3 class="text-primary mb-4">پژوهشگر گرامی</h3>

              <p>
                به ابزار حمایت از مقالات سامانه تقسیم کار ملی خوش آمدید.
                خواهشندیم ابتدا به سوالات زیر پاسخ دهید:
              </p>
              <b-form-group
                :class="proposal.faSubject ? 'done' : 'required'"
                label="عنوان نشست تخصصی"
              >
                <b-form-input trim v-model="proposal.faSubject" required>
                </b-form-input>
              </b-form-group>
              <b-form-group
                label="آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده است؟"
                :class="proposal.initialIsSupported ? 'done' : 'required'"
              >
                <b-form-radio-group v-model="proposal.initialIsSupported">
                  <b-form-radio :value="true">بله</b-form-radio>
                  <b-form-radio :value="false">خیر</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group
                label="حمایت ها:"
                v-if="proposal.initialIsSupported"
                :class="proposal.initialSupportedType ? 'done' : 'required'"
              >
                <b-form-select
                  class="myselect2"
                  id="first"
                  v-model="proposal.initialSupportedType"
                  :options="options"
                >
                </b-form-select>
              </b-form-group>
              <b-form-group
                label="عنوان حمایت دریافتی"
                v-if="
                  proposal.initialSupportedType == 'other' &&
                  proposal.initialIsSupported
                "
                :class="proposal.initialOtherSupport ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.initialOtherSupport"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                label="توضیحات حمایت دریافتی:"
                v-if="proposal.initialIsSupported"
                :class="
                  proposal.initialSupportDescription ? 'done' : 'required'
                "
              >
                <b-form-textarea
                  trim
                  rows="6"
                  v-model="proposal.initialSupportDescription"
                >
                </b-form-textarea>
              </b-form-group>

              <b-form-group
                label="لطفا حامیان برگزاری نشست را معرفی کنید:"
                :class="proposal.meetingSponsors.length ? 'done' : 'required'"
              >
                <!-- NOTE (b-addAchievment) to add achievment to achievment items table -->
                <b-button variant="success" class="mb-3 ml-1" @click="add()"
                  >+</b-button
                >

                <!-- NOTE (t-achievmentItems) to show achievment and output of proposal  -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.meetingSponsors"
                  :fields="sponsorFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="remove(data.index)"
                      >x</b-button
                    >
                  </template>

                  <template v-slot:cell(name)="data">
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </template>
                </b-table>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'اطلاعات اصلی نشست'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات نشست</h4>
              </template>
              <b-form-group label="عنوان نشست تخصصی">
                <b-form-input trim v-model="proposal.faSubject"> </b-form-input>
              </b-form-group>
              <b-form-group
                :class="proposal.meetingGoals ? 'done' : 'required'"
                label="هدف از برگزاری نشست"
              >
                <b-form-input trim v-model="proposal.meetingGoals" required>
                </b-form-input>
              </b-form-group>
              <b-form-group
                :class="proposal.meetingPlace ? 'done' : 'required'"
                label="مکان برگزاری نشست"
              >
                <b-form-input trim v-model="proposal.meetingPlace" required>
                </b-form-input>
              </b-form-group>
              <br />
              <b-row>
                <b-col cols="3">
                  <p class="mt-2">تاریخ برگزاری بین بازه زمانی</p>
                </b-col>
                <b-col cols="3">
                  <datePicker
                    color="#7b1fa2"
                    v-model="proposal.startDate"
                  ></datePicker>
                </b-col>
                <p class="mt-5">تا</p>
                <b-col cols="3">
                  <datePicker
                    :disabled="!proposal.startDate"
                    :min="proposal.finalDate"
                    color="#7b1fa2"
                    v-model="proposal.finalDate"
                  ></datePicker>
                </b-col>
                <p class="mt-5">می باشد.</p>
              </b-row>
              <div v-if="!(proposal.startDate && proposal.finalDate)">
                <b-row style="font-size: 12px">
                  <i
                    class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                    aria-hidden="true"
                    style="font-size: 18px"
                  ></i>
                  <p class="ml-2 text-danger">
                    تذکر: لطفا توجه داشته باشید که برای تعیین بازه زمانی ابتدا
                    باید تاریخ شروع را وارد نمایید
                  </p>
                </b-row>
              </div>
              <br />
              <b-form-group
                :class="proposal.meetingSchedulingFile ? 'done' : 'required'"
              >
                <b-row class="mb-2" align-v="center">
                  <b-col align-self="end">
                    <h6>برنامه زمانبندی</h6>
                  </b-col>
                  <b-col>
                    <span v-show="false">{{ check }}</span>
                    <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                    <a
                      :href="
                        filePath +
                        `/setad/private/1613804122004zamanbandi_neshast.doc`
                      "
                      class="btn btn-primary text-light"
                      target="_blank"
                      style="float: left"
                      >دانلود نمونه فایل</a
                    >
                  </b-col>
                </b-row>
                <b-form-file
                  :state="Boolean(proposal.meetingSchedulingFile)"
                  :disabled="Boolean(proposal.meetingSchedulingFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[0].file,
                      0,
                      'meetingSchedulingFile'
                    )
                  "
                  v-model="uploadedFiles[0].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[0]
                      ? files[0].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[0].uploadPercentage"
                    :value="uploadedFiles[0].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[0].striped"
                    :variant="uploadedFiles[0].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[0].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.meetingSchedulingFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.meetingSchedulingFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(0, 'meetingSchedulingFile');
                            check = !check;
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-row class="mb-2">
                <b-col>
                  <span
                    :class="
                      proposal.universityId
                        ? proposal.universityId != notUniversity
                          ? 'done'
                          : proposal.otherUniversity
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                    >دانشگاه محل برگزاری نشست</span
                  >
                </b-col>
                <b-col class="text-left">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="proposal.universityId"
                    name="checkbox-1"
                    :value="notUniversity"
                    unchecked-value=""
                    @change="reactivity = !reactivity"
                  >
                    سایر دانشگاه ها
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-form-group>
                <Select2
                  v-model="proposal.universityId"
                  :options="universities"
                  :settings="{ width: '100%' }"
                  @change="removeMehvar()"
                  :disabled="proposal.universityId == notUniversity"
                ></Select2>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherUniversity"
                  v-show="proposal.universityId == notUniversity"
                  placeholder="نام دانشگاه مورد نظر"
                  @input="reactivity = !reactivity"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                :disabled="!proposal.universityId"
                label="محور برگزاری نشست (لطفا یک گزینه را انتخاب کنید)"
                :class="
                  proposal.mehvarId
                    ? proposal.mehvarId != notMehvar
                      ? 'done'
                      : proposal.otherMehvars
                      ? 'done'
                      : 'required'
                    : 'required'
                "
              >
                <b-list-group>
                  <b-list-group-item
                    style="cursor: pointer"
                    v-for="(mehvar, index) in computedMehvars"
                    :variant="selectedMehvar == index ? 'info' : 'light'"
                    :key="index"
                    @click="
                      proposal.mehvarId = mehvar.id;
                      selectedMehvar = index;
                    "
                    :disabled="mehvar.id == 0"
                  >
                    <span v-if="selectedMehvar == index">
                      <i class="fa fa-check-circle text-success"></i>
                    </span>
                    <span v-else>
                      <i class="fa fa-circle"></i>
                    </span>
                    {{ mehvar.text }}
                  </b-list-group-item>
                </b-list-group>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherMehvars"
                  v-show="
                    proposal.mehvarId == notMehvar ||
                    proposal.universityId == notUniversity
                  "
                  placeholder="نام محور مورد نظر"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                :class="
                  proposal.zoneMedicine ||
                  proposal.zoneAgriculture ||
                  proposal.zoneEnvironment ||
                  proposal.zoneIndustrial ||
                  proposal.zoneBioComputing ||
                  proposal.zoneOther
                    ? 'done'
                    : 'required'
                "
                label="حوزه نشست:"
              >
                <b-form-checkbox v-model="proposal.zoneMedicine"
                  >پزشکی</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.zoneAgriculture"
                  >کشاورزی</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.zoneEnvironment"
                  >محیط زیست</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.zoneIndustrial"
                  >صنعتی</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.zoneBioComputing"
                  >رایانش زیستی</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.zoneOther"
                  >سایر</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'اطلاعات برگزار کننده'">
            <b-card-body>
              <b-card header-bg-variant="default" class="border-0 shadow-sm">
                <template v-slot:header>
                  <h4 class="mb-0">اطلاعات مجری برگزار کننده نشست</h4>
                </template>

                <b-card-text>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="نام"
                        :class="proposal.researcherName ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="proposal.researcherName"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="نام خانوادگی"
                        :class="
                          proposal.researcherLastName ? 'done' : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="proposal.researcherLastName"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="کدملی"
                        :class="
                          isIDClass(proposal.researcherNatCode)
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="proposal.researcherNatCode"
                          aria-describedby="input-1-live-feedback"
                          :state="isID(proposal.researcherNatCode)"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >کد ملی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-row>
                        <b-col>
                          <b-form-group
                            id="fieldset-horizontal"
                            :class="
                              proposal.researcherMobile ? 'done' : 'required'
                            "
                            description
                            label="تلفن همراه:"
                          >
                            <b-form-input
                              trim
                              v-model="proposal.researcherMobile"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6"></div>
                  </div>

                  <b-form-group
                    label="پست الکترونیکی"
                    :class="
                      isEmailClass(proposal.researcherEmail)
                        ? 'done'
                        : 'required'
                    "
                  >
                    <b-form-input
                      trim
                      :state="isEmail(proposal.researcherEmail)"
                      aria-describedby="input-1-live-feedback"
                      type="text"
                      v-model="proposal.researcherEmail"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback"
                      >پست الکترونیکی درست نیست</b-form-invalid-feedback
                    >
                  </b-form-group>

                  <b-form-group
                    label="دورنگار"
                    :class="proposal.researcherFax ? 'done' : 'required'"
                  >
                    <b-form-input
                      v-model="proposal.researcherFax"
                      :no-wheel="true"
                    ></b-form-input>
                  </b-form-group>

                  <b-row>
                    <b-col cols="6">
                      <b-form-group
                        id="fieldset-horizontal"
                        :class="
                          proposal.researcherStateId ? 'done' : 'required'
                        "
                        description
                        label="استان:"
                      >
                        <!-- <b-form-input trim  v-model="executor.state"></b-form-input> -->
                        <v-autocomplete
                          v-model="proposal.researcherStateId"
                          :items="iran"
                          @change="
                            proposal.researcherCityId = '';
                            proposal.researcherCity = '';
                            proposal.researcherState = iran.filter(
                              (x) => x.id == proposal.researcherStateId
                            )[0].name;
                            reactivity2 = !reactivity2;
                          "
                          item-value="id"
                          item-text="name"
                          dense
                          outlined
                          class="dropdown-style"
                          hide-details
                        ></v-autocomplete>
                      </b-form-group> </b-col
                    ><b-col>
                      <b-form-group
                        id="fieldset-horizontal"
                        :class="proposal.researcherCityId ? 'done' : 'required'"
                        description
                        label="شهر:"
                      >
                        <span v-show="false">{{ reactivity2 }}</span>

                        <v-autocomplete
                          v-model="proposal.researcherCityId"
                          :items="
                            iran
                              .filter((x) => x.id == proposal.researcherStateId)
                              .map((y) => y.cities)[0]
                          "
                          item-value="id"
                          item-text="name"
                          dense
                          outlined
                          class="dropdown-style"
                          hide-details
                          @change="
                            reactivity2 = !reactivity2;
                            proposal.researcherCity = iran
                              .filter(
                                (x) => x.id == proposal.researcherStateId
                              )[0]
                              .cities.filter(
                                (y) => y.id == proposal.researcherCityId
                              )[0].name;
                          "
                        ></v-autocomplete>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <span :class="universityClass">دانشگاه محل تحصیل</span>
                    </b-col>
                    <b-col class="text-left">
                      <b-form-checkbox
                        id="checkbox-2"
                        v-model="proposal.researcherUniversityId"
                        name="checkbox-2"
                        :value="notUniversity"
                        unchecked-value=""
                        @change="reactivity = !reactivity"
                      >
                        سایر دانشگاه ها
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-form-group>
                    <Select2
                      v-model="proposal.researcherUniversityId"
                      :options="universities"
                      :settings="{ width: '100%' }"
                      :disabled="
                        proposal.researcherUniversityId == notUniversity
                      "
                    ></Select2>
                    <b-form-input
                      trim
                      class="mt-1"
                      v-model="proposal.researcherUniversityOther"
                      v-show="proposal.researcherUniversityId == notUniversity"
                      placeholder="نام دانشگاه"
                      @input="reactivity = !reactivity"
                    ></b-form-input>
                  </b-form-group>
                  <b-row class="mb-2">
                    <b-col>
                      <span :class="universityJobClass"
                        >دانشگاه محل اشتغال به عنوان عضوهئیت علمی</span
                      >
                    </b-col>
                    <b-col class="text-left">
                      <b-form-checkbox
                        id="checkbox-3"
                        v-model="proposal.researcherUniversityJobId"
                        name="checkbox-3"
                        :value="notUniversity"
                        unchecked-value=""
                        @change="reactivity = !reactivity"
                      >
                        سایر دانشگاه ها
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-form-group>
                    <Select2
                      v-model="proposal.researcherUniversityJobId"
                      :options="universities"
                      :settings="{ width: '100%' }"
                      :disabled="
                        proposal.researcherUniversityJobId == notUniversity
                      "
                    ></Select2>
                    <b-form-input
                      trim
                      class="mt-1"
                      v-model="proposal.researcherUniversityJobOther"
                      v-show="
                        proposal.researcherUniversityJobId == notUniversity
                      "
                      placeholder="نام دانشگاه"
                      @input="reactivity = !reactivity"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="آخرین مدرک تحصیلی"
                    :class="proposal.researcherLastDegree ? 'done' : 'required'"
                  >
                    <b-form-select
                      :options="lastDegree"
                      v-model="proposal.researcherLastDegree"
                    >
                    </b-form-select>
                  </b-form-group>
                  <b-form-group label="نشست های تخصصی برگزار شده را بیان کنید:">
                    <!-- NOTE (b-addAchievment) to add achievment to achievment items table -->
                    <b-button
                      variant="success"
                      class="mb-3 ml-1"
                      @click="addMeeting()"
                      >+</b-button
                    >

                    <!-- NOTE (t-achievmentItems) to show achievment and output of proposal  -->
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.researcherMeetings"
                      :fields="meetingFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <template v-slot:cell(operation)="data">
                        <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
                        <b-button
                          variant="danger"
                          class="mr-2"
                          @click="delMeeting(data.index)"
                          >x</b-button
                        >
                      </template>

                      <template v-slot:cell(meetingSubject)="data">
                        <b-form-input
                          trim
                          v-model="data.item.meetingSubject"
                          type="text"
                        ></b-form-input>
                      </template>

                      <template v-slot:cell(meetingPlace)="data">
                        <b-form-input
                          trim
                          v-model="data.item.meetingPlace"
                          type="text"
                          rows="6"
                          max-rows="6"
                        ></b-form-input>
                      </template>
                      <template v-slot:cell(meetingDate)="data">
                        <datePicker
                          color="#7b1fa2"
                          v-model="data.item.meetingDate"
                        ></datePicker>
                      </template>
                      <template v-slot:cell(supporterOrg)="data">
                        <b-form-input
                          trim
                          v-model="data.item.supporterOrg"
                          type="text"
                          rows="6"
                          max-rows="6"
                        ></b-form-input>
                      </template>
                    </b-table>
                  </b-form-group>
                  <b-form-group label="کارگاه های برگزار شده را بیان کنید:">
                    <!-- NOTE (b-addAchievment) to add achievment to achievment items table -->
                    <b-button
                      variant="success"
                      class="mb-3 ml-1"
                      @click="addWorkshop()"
                      >+</b-button
                    >

                    <!-- NOTE (t-achievmentItems) to show achievment and output of proposal  -->
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.researcherWorkshops"
                      :fields="workshopFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <template v-slot:cell(operation)="data">
                        <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
                        <b-button
                          variant="danger"
                          class="mr-2"
                          @click="delWorkshop(data.index)"
                          >x</b-button
                        >
                      </template>

                      <template v-slot:cell(workshopSubject)="data">
                        <b-form-input
                          trim
                          v-model="data.item.workshopSubject"
                          type="text"
                        ></b-form-input>
                      </template>

                      <template v-slot:cell(workshopPlace)="data">
                        <b-form-input
                          trim
                          v-model="data.item.workshopPlace"
                          type="text"
                          rows="6"
                          max-rows="6"
                        ></b-form-input>
                      </template>
                      <template v-slot:cell(workshopDate)="data">
                        <datePicker
                          color="#7b1fa2"
                          v-model="data.item.workshopDate"
                        ></datePicker>
                      </template>
                      <template v-slot:cell(workshopSupporterOrg)="data">
                        <b-form-input
                          trim
                          v-model="data.item.workshopSupporterOrg"
                          type="text"
                          rows="6"
                          max-rows="6"
                        ></b-form-input>
                      </template>
                    </b-table>
                  </b-form-group>
                </b-card-text>
              </b-card>
            </b-card-body>
          </b-tab>
          <b-tab :title="'برگزار کنندگان'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات برگزار کنندگان</h4>
              </template>
              <b-form-group>
                <!-- NOTE (b-addAchievment) to add achievment to achievment items table -->
                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addOrganizer()"
                  >+</b-button
                >

                <!-- NOTE (t-achievmentItems) to show achievment and output of proposal  -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.colleagues"
                  :fields="organizersFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delOrganizer(data.index)"
                      >x</b-button
                    >
                  </template>

                  <template v-slot:cell(name)="data">
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </template>

                  <template v-slot:cell(lastName)="data">
                    <b-form-input
                      trim
                      v-model="data.item.lastName"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </template>

                  <template v-slot:cell(cooperationType)="data">
                    <b-form-input
                      trim
                      v-model="data.item.cooperationType"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(position)="data">
                    <b-form-input
                      trim
                      v-model="data.item.position"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(mobile)="data">
                    <b-form-input
                      trim
                      v-model="data.item.mobile"
                      type="number"
                      :no-wheel="true"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(email)="data">
                    <b-form-input
                      trim
                      v-model="data.item.email"
                      :state="isEmail(data.item.email)"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </template>
                </b-table>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'زمان‌بندی'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">شرح خدمات، زمان‌بندی و فازبندی نشست</h4>
              </template>

              <b-form-group>
                <!-- NOTE (b-addService) to add a row to service items table -->
                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addService()"
                  >+</b-button
                >

                <!-- NOTE (t-serviceItems) to show informations of phase scheduling, activities description and weight percentage of activity  -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.gantData"
                  :fields="serviceFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(report)="data">
                    <b-form-checkbox
                      :id="'tooltip-target-' + data.index"
                      v-model="data.item.report"
                    ></b-form-checkbox>
                    <b-tooltip
                      placement="top"
                      :show="myshow"
                      delay="100"
                      :target="'tooltip-target-' + data.index"
                      >درصورت ارائه گزارش در پایان این فاز به ستاد، انتخاب
                      نمایید</b-tooltip
                    >
                  </template>
                  <template v-slot:cell(cellColor)="data">
                    <div>
                      <ColourPicker
                        ref="colorPicker"
                        no-input
                        picker="compact"
                        :color="data.item.cellColor"
                        :value="data.item.cellColor"
                        v-model="data.item.cellColor"
                      />
                    </div>
                  </template>

                  <template v-slot:cell(operation)="data">
                    <div>
                      <!-- NOTE (b-delService) to remove a row from service items table -->
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delService(data.index)"
                      >
                        <i class="fa fa-times" />
                      </b-button>
                    </div>
                  </template>

                  <template v-slot:cell(description)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.description"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>

                  <template v-slot:cell(percent)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.percent"
                        type="number"
                        :no-wheel="true"
                        min="0"
                        max="100"
                        :state="
                          data.item.percent > 0 && data.item.percent <= 100
                        "
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(startDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.startDate"
                        @change="changedStartDate(data.item, data.index)"
                      ></date-picker>
                    </div>
                  </template>
                  <template v-slot:cell(dueDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.dueDate"
                        :min="computedMinDate(data.item.startDate)"
                      ></date-picker>
                    </div>
                  </template>
                </b-table>

                <sarmadGantt
                  :items="proposal.gantData"
                  :fields="serviceFields"
                />

                <p
                  :class="
                    proposal.gantData
                      .map((x) => x.percent)
                      .reduce((a, b) => Number(a) + Number(b), 0) == 100
                      ? 'done'
                      : 'required'
                  "
                >
                  توجه داشته باشید که مجموع درصد وزنی فعالیت باید 100 درصد باشد.
                  درصد فعلی:
                  {{
                    proposal.gantData.length == 0
                      ? 0
                      : proposal.gantData
                          .map((x) => x.percent)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                  }}
                  %
                </p>
              </b-form-group>
            </b-card>
          </b-tab>

          <b-tab :title="'فایل‌های تکمیلی'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">فایل‌ها</h4>
              </template>
              <b-form-group
                label="رزومه مجری"
                :class="proposal.researcherResumeFile ? 'done' : 'required'"
              >
                <b-form-file
                  :state="Boolean(proposal.researcherResumeFile)"
                  :disabled="Boolean(proposal.researcherResumeFile)"
                  @input="
                    uploadFile(uploadedFiles[1].file, 1, 'researcherResumeFile')
                  "
                  v-model="uploadedFiles[1].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[1]
                      ? files[1].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[1].uploadPercentage"
                    :value="uploadedFiles[1].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[1].striped"
                    :variant="uploadedFiles[1].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[1].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.researcherResumeFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.researcherResumeFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(1, 'researcherResumeFile');
                            check = !check;
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group label="سایر مدارک (1)">
                <b-row class="mb-2">
                  <b-col>
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile1Title"
                      placeholder="عنوان"
                    ></b-form-input>
                  </b-col>
                  <b-col>
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile1Description"
                      placeholder="توضیحات"
                    ></b-form-input
                  ></b-col>
                </b-row>

                <b-form-file
                  @input="uploadFile(uploadedFiles[2].file, 2, 'otherFile1')"
                  :disabled="Boolean(proposal.otherFile1)"
                  v-model="uploadedFiles[2].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[2]
                      ? files[2].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[2].uploadPercentage"
                    :value="uploadedFiles[2].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[2].striped"
                    :variant="uploadedFiles[2].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[2].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile1" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.otherFile1"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(2, 'otherFile1');
                            check = !check;
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group label="سایر مدارک (2)">
                <b-row class="mb-2">
                  <b-col>
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile2Title"
                      placeholder="عنوان"
                    ></b-form-input>
                  </b-col>
                  <b-col>
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile2Description"
                      placeholder="توضیحات"
                    ></b-form-input
                  ></b-col>
                </b-row>
                <b-form-file
                  @input="uploadFile(uploadedFiles[3].file, 3, 'otherFile2')"
                  :disabled="Boolean(proposal.otherFile2)"
                  v-model="uploadedFiles[3].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[3]
                      ? files[3].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[3].uploadPercentage"
                    :value="uploadedFiles[3].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[3].striped"
                    :variant="uploadedFiles[3].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[3].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile2" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.otherFile2"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(3, 'otherFile2');
                            check = !check;
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group label="سایر مدارک (3)">
                <b-row class="mb-2">
                  <b-col>
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile3Title"
                      placeholder="عنوان"
                    ></b-form-input>
                  </b-col>
                  <b-col>
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile3Description"
                      placeholder="توضیحات"
                    ></b-form-input
                  ></b-col>
                </b-row>
                <b-form-file
                  @input="uploadFile(uploadedFiles[4].file, 4, 'otherFile3')"
                  :disabled="Boolean(proposal.otherFile3)"
                  v-model="uploadedFiles[4].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[4]
                      ? files[4].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[4].uploadPercentage"
                    :value="uploadedFiles[4].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[4].striped"
                    :variant="uploadedFiles[4].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[4].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile3" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.otherFile3"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(4, 'otherFile3');
                            check = !check;
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <!-- NOTE (t-fileFields) to show uploded files and each file is downloadable  -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="fileFields"
                :items="files.filter((x) => x && x.url != '')"
                empty-text="فایلی وجود ندارد"
                striped
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>

                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(url)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <!-- NOTE (<a>) to download the user uploaded file by opening a new page -->
                    <a
                      v-if="data.value"
                      class="btn btn-success"
                      :href="data.value"
                      target="_blank"
                      >دریافت فایل</a
                    >
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
            </b-card>
          </b-tab>
          <b-tab :title="'تعهدات'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">تعهدات</h4>
              </template>

              <b-form-group>
                <b-form-checkbox
                  :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[0]"
                  >با توجه به آیین نامه تمامی مستندات در پایان نشست در سامانه
                  بارگذاری خواهد شد
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[1]"
                  >گزارش برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد ارائه می
                  شود
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[2]"
                  >عکس های برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد ارائه می
                  شود می‌باشد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[3]"
                  >پوستر نشست قبل از چاپ به تایید گروه پژوهش خواهد
                  رسید.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[4]"
                  >متن خبر پیش از برگزاری جهت درج در سایت به همراه پوستر تایید
                  شده به گروه پژوهش ارسال می شود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[5]"
                  >هماهنگی مناسب با ناظر نشست صورت خواهد گرفت
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[6]"
                  >پذیرایی از شرکت کنندگان طبق آیین نامه صورت خواهد
                  گرفت.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[7]"
                  >گواهی نامه ها طبق آیین نامه و با هماهنگی گروه پژوهش تهیه و در
                  اختیار شرکت کنندگان قرار می گیرد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[8]"
                  >لینک اخبار و مستندات و گزارش ها روی سامانه بارگذاری خواهد
                  شد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[9]"
                  >کتابچه برگزاری نشست با هماهنگی گروه پژوهش تهیه و در اختیار
                  ستاد قرار می گیرد.</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'مرور نهایی و ارسال'">
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 border-0"
                role="tab"
              >
                <b-button block v-b-toggle.accordion-1 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    عنوان و حمایت‌های پیشین&nbsp;
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 0"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b> عنوان به زبان فارسی:</b> {{ proposal.faSubject }}
                      </li>
                      <li class="done">
                        <b
                          >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها
                          استفاده کرده است؟</b
                        >
                        <b-form-radio-group
                          v-model="proposal.initialIsSupported"
                          disabled
                        >
                          <b-form-radio :value="true">بله</b-form-radio>
                          <b-form-radio :value="false">خیر</b-form-radio>
                        </b-form-radio-group>
                      </li>

                      <li
                        v-if="proposal.initialIsSupported"
                        :class="
                          proposal.initialSupportedType ? 'done' : 'required'
                        "
                      >
                        <b>حمایت ها:</b
                        >{{
                          proposal.initialSupportedType
                            ? options.filter(
                                (x) => x.value == proposal.initialSupportedType
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="
                          proposal.initialSupportedType == 'other' &&
                          proposal.initialIsSupported
                        "
                        :class="
                          proposal.initialOtherSupport ? 'done' : 'required'
                        "
                      >
                        <b>عنوان حمایت دریافتی:</b
                        >{{ proposal.initialOtherSupport }}
                      </li>
                      <li
                        v-if="proposal.initialIsSupported"
                        :class="
                          proposal.initialSupportDescription
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>توضیحات حمایت دریافتی:</b
                        >{{ proposal.initialSupportDescription }}
                      </li>
                      <br />

                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.meetingSponsors"
                        :fields="sponsorFields"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 border-0"
                role="tab"
              >
                <b-button block v-b-toggle.accordion-2 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات نشست
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 1"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-2"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b> عنوان نشست تخصصی:</b> {{ proposal.faSubject }}
                      </li>
                      <li :class="proposal.meetingGoals ? 'done' : 'required'">
                        <b>هدف از برگزاری نشست:</b> {{ proposal.meetingGoals }}
                      </li>
                      <li :class="proposal.meetingPlace ? 'done' : 'required'">
                        <b> مکان برگزاری نشست:</b> {{ proposal.meetingPlace }}
                      </li>
                      <b-row class="font-weight-bold">
                        <p class="mt-2 mr-1">تاریخ برگزاری بین بازه زمانی</p>
                        <span class="mt-2 mr-1">{{ proposal.startDate }}</span>
                        <p class="mt-2 mr-1">تا</p>
                        <span class="mt-2 mr-1">{{ proposal.finalDate }}</span>
                        <p class="mt-2 mr-1">می باشد.</p>
                      </b-row>
                      <li :class="proposal.universityId ? 'done' : 'required'">
                        <b>دانشگاه محل برگزاری نشست:</b>
                        {{
                          proposal.universityId
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.universityId == notUniversity"
                        :class="proposal.otherUniversity ? 'done' : 'required'"
                      >
                        <b>نام دانشگاه:</b> {{ proposal.otherUniversity }}
                      </li>
                      <li
                        v-if="proposal.mehvarId != notMehvar && mehvars.length"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور طرح:</b>
                        {{ mehvarr }}
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور طرح:</b> سایر محورها
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.otherMehvars ? 'done' : 'required'"
                      >
                        <b>نام محور:</b> {{ proposal.otherMehvars }}
                      </li>
                      <li
                        :class="
                          proposal.zoneMedicine ||
                          proposal.zoneAgriculture ||
                          proposal.zoneEnvironment ||
                          proposal.zoneIndustrial ||
                          proposal.zoneBioComputing ||
                          proposal.zoneOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>حوزه طرح:</b>
                        <b-form-group disabled>
                          <b-form-checkbox v-model="proposal.zoneMedicine"
                            >پزشکی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneAgriculture"
                            >کشاورزی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneEnvironment"
                            >محیط زیست</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneIndustrial"
                            >صنعتی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneBioComputing"
                            >رایانش زیستی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneOther"
                            >سایر</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-3 variant="light">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات مجری برگزار کننده نشست
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 2"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <!-- NOTE (t-personnelCost) to show personnel costs with details about each personnel -->
                    <ul>
                      <li
                        :class="proposal.researcherName ? 'done' : 'required'"
                      >
                        <b>نام:</b> {{ proposal.researcherName }}
                      </li>
                      <li
                        :class="
                          proposal.researcherLastName ? 'done' : 'required'
                        "
                      >
                        <b>نام خانوادگی:</b> {{ proposal.researcherLastName }}
                      </li>
                      <li
                        :class="proposal.researcherMobile ? 'done' : 'required'"
                      >
                        <b>تلفن همراه:</b> {{ proposal.researcherMobile }}
                      </li>
                      <li
                        :class="
                          proposal.researcherNatCode ? 'done' : 'required'
                        "
                      >
                        <b>کدملی:</b> {{ proposal.researcherNatCode }}
                      </li>
                      <li
                        :class="proposal.researcherEmail ? 'done' : 'required'"
                      >
                        <b>پست الکترونیکی:</b> {{ proposal.researcherEmail }}
                      </li>
                      <li :class="proposal.researcherFax ? 'done' : 'required'">
                        <b>دورنگار:</b> {{ proposal.researcherFax }}
                      </li>
                      <li
                        :class="
                          proposal.researcherStateId ? 'done' : 'required'
                        "
                      >
                        <b> استان:</b>
                        {{
                          proposal.researcherState
                            ? proposal.researcherState
                            : "-"
                        }}
                      </li>
                      <li
                        :class="proposal.researcherCityId ? 'done' : 'required'"
                      >
                        <b> شهر:</b>
                        {{
                          proposal.researcherCity
                            ? proposal.researcherCity
                            : "-"
                        }}
                      </li>
                      <li
                        :class="
                          proposal.researcherUniversityId ? 'done' : 'required'
                        "
                      >
                        <b>دانشگاه محل تحصیل:</b>
                        {{
                          proposal.researcherUniversityId
                            ? universities.filter(
                                (x) => x.id == proposal.researcherUniversityId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.researcherUniversityId == notUniversity"
                        :class="
                          proposal.researcherUniversityOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b> نام دانشگاه:</b>
                        {{ proposal.researcherUniversityOther }}
                      </li>
                      <li :class="universityJobClass">
                        <b>دانشگاه محل اشتغال به عنوان عضوهئیت علمی:</b>
                        {{
                          proposal.researcherUniversityJobId
                            ? universities.filter(
                                (x) =>
                                  x.id == proposal.researcherUniversityJobId
                              )[0].text
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="
                          proposal.researcherUniversityJobId == notUniversity
                        "
                      >
                        <b>نام دانشگاه:</b>
                        {{ proposal.researcherUniversityJobOther }}
                      </li>
                      <li
                        :class="
                          proposal.researcherLastDegree ? 'done' : 'required'
                        "
                      >
                        <b> آخرین مدرک تحصیلی:</b>
                        {{ proposal.researcherLastDegree }}
                      </li>
                      <b-form-group label="نشست های تخصصی برگزار شده:">
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="proposal.researcherMeetings"
                          :fields="meetingFields"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                        </b-table>
                      </b-form-group>
                      <b-form-group label="کارگاه های برگزار شده:">
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="proposal.researcherWorkshops"
                          :fields="workshopFields"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                        </b-table>
                      </b-form-group>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-4 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    برگزار کنندگان
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 3"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-4"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b-form-group>
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.colleagues"
                        :fields="organizersFields"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                    </b-form-group>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-5 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    زمانبندی
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 4"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-5"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b> زمان شروع:</b>
                    {{
                      proposal.gantData.length > 0
                        ? moment(
                            new Date(
                              Math.min(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.startDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )
                            )
                          ).format("jYYYY/jMM/jDD")
                        : ""
                    }}
                    <br />
                    <b>زمان پایان:</b>
                    {{
                      proposal.gantData.length > 0
                        ? moment(
                            new Date(
                              Math.max(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )
                            )
                          ).format("jYYYY/jMM/jDD")
                        : ""
                    }}
                    <br />
                    <b>مدت زمان:</b>
                    {{
                      proposal.gantData.length > 0
                        ? (Math.max(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          ) -
                            Math.min(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.startDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )) /
                            3600 /
                            24 /
                            1000 +
                          " روز"
                        : ""
                    }}
                    <br />
                    <div>
                      <sarmadGantt
                        :items="proposal.gantData"
                        :fields="serviceFields"
                      />
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-6 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    فایل‌های تکمیلی
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 5"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-6"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <h5>در این جدول کلیه فایل‌های نشست را مشاهده میفرمایید.</h5>
                    <b-table
                      responsive
                      show-empty
                      head-variant="dark"
                      :fields="fileFields"
                      :items="files.filter((x) => x && x.url != '')"
                      empty-text="فایلی وجود ندارد"
                      striped
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>

                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(url)="data">
                        <div style="text-align: center; vertical-align: middle">
                          <!-- NOTE (<a>) to download the user uploaded file by opening a new page -->
                          <a
                            v-if="data.value"
                            class="btn btn-success"
                            :href="data.value"
                            target="_blank"
                            >دریافت فایل</a
                          >
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <strong>در حال بارگذاری...</strong>
                        <br />
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </b-table>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-7 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 6"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-7"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b-form-group disabled>
                      <b-form-checkbox
                        :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[0]"
                        >با توجه به آیین نامه تمامی مستندات در پایان نشست در
                        سامانه بارگذاری خواهد شد.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[1]"
                        >گزارش برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد
                        ارائه می شود.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[2]"
                        >عکس های برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد
                        ارائه می شود می‌باشد.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[3]"
                        >پوستر نشست قبل از چاپ به تایید گروه پژوهش خواهد
                        رسید.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[4]"
                        >متن خبر پیش از برگزاری جهت درج در سایت به همراه پوستر
                        تایید شده به گروه پژوهش ارسال می شود.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[5]"
                        >هماهنگی مناسب با ناظر نشست صورت خواهد
                        گرفت.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[6]"
                        >پذیرایی از شرکت کنندگان طبق آیین نامه صورت خواهد
                        گرفت.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[7]"
                        >گواهی نامه ها طبق آیین نامه و با هماهنگی گروه پژوهش
                        تهیه و در اختیار شرکت کنندگان قرار می
                        گیرد.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[8]"
                        >لینک اخبار و مستندات و گزارش ها روی سامانه بارگذاری
                        خواهد شد.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[9]"
                        >کتابچه برگزاری نشست با هماهنگی گروه پژوهش تهیه و در
                        اختیار ستاد قرار می گیرد.</b-form-checkbox
                      >
                    </b-form-group>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-button
              class="m-2"
              variant="success"
              :disabled="sending"
              @click="submit()"
              >ارسال</b-button
            >
          </b-tab>
        </b-tabs>
        <div class="d-flex justify-content-center mt-3">
          <!-- NOTE (b-previousPage-2) previous -->
          <b-button
            v-if="tabIndex != 0"
            class="mx-1"
            variant="light"
            @click="changePage('back')"
            >مرحله قبل</b-button
          >

          <!-- NOTE (b-nextPage-2) previous -->
          <b-button
            v-if="tabIndex != 7"
            class="mx-1"
            variant="primary"
            @click="changePage('next')"
            >مرحله بعد</b-button
          >
        </div>
      </b-card>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import GSTC from "vue-gantt-schedule-timeline-calendar";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("../../components/sarmadGantt");
import { Compact } from "vue-color"; // REVIEW
import ColourPicker from "vue-colour-picker"; // REVIEW
import mixin from "../../mixins/utilities";

export default {
  mixins: [mixin],
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    GSTC,
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    compact: Compact,
    ColourPicker,
  },
  data() {
    return {
      reactivity: false,
      reactivity2: false,
      otherUniHelp: "",
      otherUniJobHelp: "",
      universityJobHelp: "",
      isSaving: false,
      max: 100,
      infoo: "",
      moment: moment,
      checkbox: "",
      checkbox2: "",
      show: false,
      busy: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      colleaguesData: [],
      serviceItems: [],
      selectedColleague: "",
      executor: {},
      proposal: {
        meetingSponsors: [],
        researcherWorkshops: [],
        colleagues: [],
        researcherMeetings: [],
        gantData: [],
        promiseArrays: [],
        researcherId: 0,
        researcherResumeFile: "",
        otherFile1: "",
        otherFile2: "",
        otherFile3: "",
      },
      sending: false,
      researchers: [],
      promises: {},
      colleague: {},
      universities: [],
      iran: [],
      otherUniversity: "",
      mehvars: [],
      otherMehvars: "",
      zone: JSON.parse(JSON.stringify(new Array(6).fill(false))),
      achievmentitems: [],
      tabIndex: 1,
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      selectedMehvar: 0,
      taahol: "",
      DoiItem: [],
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      inventionItem: [],
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "year", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      fileTitles: [
        "برنامه زمانبندی",
        "رزومه مجری",
        "سایر مدارک (1)",
        "سایر مدارک (2)",
        "سایر مدارک (3)",
      ],
      //myFile: [
      //  { isUploaded: false, uploadPercentage: 0 },
      //  { isUploaded: false, uploadPercentage: 0 },
      //  { isUploaded: false, uploadPercentage: 0 },
      //  { isUploaded: false, uploadPercentage: 0 },
      //  { isUploaded: false, uploadPercentage: 0 },
      //  { isUploaded: false, uploadPercentage: 0 },
      //  { isUploaded: false, uploadPercentage: 0 },
      //],
      check: false,
      //descriptionTemplates: [
      //  { title: "", description: "برنامه زمانبندی" },
      //  { title: "", description: "رزومه مجری" },
      //  { title: "", description: "آپلود گزارش" },
      //  { title: "", description: "فایل پروپوزال" },
      //  { title: "", description: "" },
      //  { title: "", description: "" },
      //  { title: "", description: "" },
      //],
      //myTempFile0: false,
      //myTempFile1: false,
      //myTempFile2: false,
      //myTempFile3: false,
      //myTempFile4: false,
      //myTempFile5: false,
      //myTempFile6: false,
      //file: JSON.parse(JSON.stringify(new Array(7).fill(null))),
      uploadedFiles: new Array(5).fill({
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      }),
      files: [
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
      ],
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      sponsoritems: [],
      sponsorFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام حامی" },
        { key: "operation", label: "" },
      ],
      OrgCostItem: [],
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
        { key: "operation", label: "" },
      ],

      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
        { key: "operation", label: "" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      //additionalFiles: {
      //  zero: { uploadPercentage: 0 },
      //  research: { uploadPercentage: 0 },
      //  industry: { uploadPercentage: 0 },
      //  agreement: { uploadPercentage: 0 },
      //  others1: { uploadPercentage: 0 },
      //  others2: { uploadPercentage: 0 },
      //  others3: { uploadPercentage: 0 },
      //},
      meetingitems: [],
      meetingFields: [
        { key: "index", label: "ردیف" },
        { key: "meetingSubject", label: "عنوان نشست" },
        { key: "meetingPlace", label: "محل برگزاری" },
        { key: "meetingDate", label: "تاریخ برگزاری" },
        { key: "supporterOrg", label: "سازمان حمایت کننده" },
        { key: "operation", label: "" },
      ],
      workshopitems: [],
      workshopFields: [
        { key: "index", label: "ردیف" },
        { key: "workshopSubject", label: "عنوان کارگاه برگزار شده" },
        { key: "workshopPlace", label: "محل برگزاری" },
        { key: "workshopDate", label: "تاریخ برگزاری" },
        { key: "workshopSupporterOrg", label: "سازمان حمایت کننده" },
        { key: "operation", label: "" },
      ],
      organizersitems: [],
      organizersFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "lastName", label: "نام خانوادگی" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "position", label: "سمت" },
        { key: "mobile", label: "شماره تماس" },
        { key: "email", label: "ایمیل" },
        { key: "operation", label: "" },
      ],
      //otherFiles: JSON.parse(
      //  JSON.stringify(
      //    new Array(10).fill({
      //      isUploaded: false,
      //    })
      //  )
      //),
      config: {
        locale: {
          name: "en",
        },
        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          time: {
            zoom: 12,
          },
          items: {},
        },
      },
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],
      isLoaded: true,
      showTop: false,
      gettingMobile: false,
      pageLoaded: false,
    };
  },

  methods: {
    showAcount() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/researcher/getInfo",
          {
            researcherId: this.proposal.researcherId,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal.researcherName = "";
          this.proposal.researcherLastName = "";
          this.proposal.researcherNatCode = "";
          this.proposal.researcherMobile = "";
          this.proposal.researcherFax = "";
          this.proposal.researcherEmail = "";
          this.proposal.researcherState = "";
          this.proposal.researcherCity = "";
          this.proposal.researcherStateId = "";
          this.proposal.researcherCityId = "";
          this.proposal.researcherUniversityId = "";
          this.proposal.researcherUniversityJobId = "";
          this.proposal.researcherLastDegree = "";
          //////////////////////////////////////////
          this.executor = res.data.researcher;
          this.proposal.researcherName = this.executor.name;
          this.proposal.researcherLastName = this.executor.lastName;
          this.proposal.researcherNatCode = this.executor.natCode;
          this.proposal.researcherMobile = this.executor.mobile;
          this.proposal.researcherFax = this.executor.fax;
          this.proposal.researcherEmail = this.executor.email;
          this.proposal.researcherState = this.executor.state;
          this.proposal.researcherCity = this.executor.city;
          this.proposal.researcherStateId = this.executor.stateId;
          this.proposal.researcherCityId = this.executor.cityId;
          this.proposal.researcherUniversityId = this.executor.universityId;
          this.proposal.researcherUniversityJobId =
            this.executor.universityJobId;
          this.proposal.researcherLastDegree = this.executor.lastDegree;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeMehvar() {
      this.proposal.mehvarId = "";
      this.otherMehvars = "";
    },
    delFile(order, fileName) {
      this.uploadedFiles[order] = {
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      };
      this.files[order] = {
        showName: "",
        url: "",
        title: "",
        id: "",
      };
      this.proposal[fileName] = "";
      this.proposal[fileName + "Id"] = "";
    },
    changePage(direction) {
      // NOTE (m-changePage) to go to the previous and next step in each step
      direction == "back" ? this.tabIndex-- : this.tabIndex++;

      // Scroll to Top
      window.scrollTo(0, 0);
    },
    submit() {
      this.sending = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/meeting/fastSub",
          {
            requestId: this.$route.params.id,
            researcherId: this.proposal.researcherId,
            uploadedFiles: this.files,
            faSubject: this.proposal.faSubject,
            initialIsSupported: this.proposal.initialIsSupported,
            initialSupportedType: this.proposal.initialSupportedType,
            initialOtherSupport: this.proposal.initialOtherSupport,
            initialSupportDescription: this.proposal.initialSupportDescription,
            meetingGoals: this.proposal.meetingGoals,
            meetingPlace: this.proposal.meetingPlace,
            universityId: this.proposal.universityId,
            otherUniversity: this.proposal.otherUniversity,
            mehvarId: this.proposal.mehvarId,
            otherMehvars: this.proposal.otherMehvars,
            zoneMedicine: this.proposal.zoneMedicine,
            zoneAgriculture: this.proposal.zoneAgriculture,
            zoneEnvironment: this.proposal.zoneEnvironment,
            zoneIndustrial: this.proposal.zoneIndustrial,
            zoneBioComputing: this.proposal.zoneBioComputing,
            zoneOther: this.proposal.zoneOther,
            researcherName: this.proposal.researcherName,
            researcherLastName: this.proposal.researcherLastName,
            researcherMobile: this.proposal.researcherMobile,
            researcherEmail: this.proposal.researcherEmail,
            researcherNatCode: this.proposal.researcherNatCode,
            researcherFax: this.proposal.researcherFax,
            researcherCityId: this.proposal.researcherCityId ? this.proposal.researcherCityId : null,
            researcherStateId: this.proposal.researcherStateId ? this.proposal.researcherStateId : null,
            researcherUniversityId: this.proposal.researcherUniversityId,
            researcherUniversityOther: this.proposal.researcherUniversityOther,
            researcherUniversityJobId: this.proposal.researcherUniversityJobId,
            researcherUniversityJobOther:
              this.proposal.researcherUniversityJobOther,
            researcherLastDegree: this.proposal.researcherLastDegree,
            researcherMeetings: this.proposal.researcherMeetings,
            researcherWorkshops: this.proposal.researcherWorkshops,
            colleagues: this.proposal.colleagues,
            gantData: this.proposal.gantData,
            startDate: this.proposal.startDate,
            finalDate: this.proposal.finalDate,
            meetingSchedulingFileId: this.proposal.meetingSchedulingFileId,
            researcherResumeFileId: this.proposal.researcherResumeFileId,
            otherFile1Id: this.proposal.otherFile1Id,
            otherFile1Title: this.proposal.otherFile1Title,
            otherFile1Description: this.proposal.otherFile1Description,
            otherFile2Id: this.proposal.otherFile2Id,
            otherFile2Title: this.proposal.otherFile2Title,
            otherFile2Description: this.proposal.otherFile2Description,
            otherFile3Id: this.proposal.otherFile3Id,
            otherFile3Title: this.proposal.otherFile3Title,
            otherFile3Description: this.proposal.otherFile3Description,
            promiseArrays: this.proposal.promiseArrays,
            meetingSponsors: this.proposal.meetingSponsors,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast("درخواست با موفقیت در سامانه به ثبت رسید.", "success");
          this.sending = false;
          router.push("/admin/meeting/" + res.data);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.sending = false;
        });
    },
    changedStartDate(data, index) {
      if (
        moment(data.startDate, "jYYYY/jM/JD").format("X") >
        moment(data.dueDate, "jYYYY/jM/JD").format("X")
      ) {
        this.proposal.gantData[index].dueDate = this.computedMinDate(
          data.startDate
        );
      }
    },
    add() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.proposal.meetingSponsors.push({
        name: "",
      });
      const title = (
        <div>
          <h5>!دستاورد جدید افزوده شد</h5>
          <span>لطفا اطلاعات دستاورد جدید را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    remove(order) {
      this.proposal.meetingSponsors.splice(order, 1);
    },
    uploadFile(file, index, fileName) {
      // NOTE to upload files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.uploadedFiles[index].showProgress = true;
        this.uploadedFiles[index].variant = "info";
        this.uploadedFiles[index].uploadPercentage = 0;
        this.uploadedFiles[index].isUploaded = false;
        this.uploadedFiles[index].uploadButDisable = true;

        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/meeting/upload",
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.uploadedFiles[index].uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.uploadedFiles[index].isUploaded = true;
              this.uploadedFiles[index].uploadPercentage = 100;
              this.uploadedFiles[index].striped = false;
              this.uploadedFiles[index].variant = "success";
              this.uploadedFiles[index].uploadButDisable = false;
              this.proposal[fileName] = d.data.url;
              this.proposal[fileName + "Id"] = d.data.id;
              this.files[index] = d.data;
              this.files[index].title = this.fileTitles[index];

              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.uploadedFiles[index].uploadPercentage = 0;
            this.uploadedFiles[index].isUploaded = false;
          });
      }
    },
    isEmail(email) {
      // NOTE (m-isEmail) to check the validity of the email
      return email ? (this.validateEmail(email) ? null : false) : null;
    },
    isEmailClass(email) {
      // NOTE (m-isEmail) to check the validity of the email
      return email ? (this.validateEmail(email) ? true : false) : false;
    },
    isID(id) {
      // NOTE to check the validity of the national code
      return id ? (this.checkCodeMeli(id) ? null : false) : null;
    },
    isIDClass(id) {
      // NOTE to check the validity of the national code
      return id ? (this.checkCodeMeli(id) ? true : false) : false;
    },
    //addAchievment() {
    //  // NOTE (m-addAchievment) to add achievements in the relevant sections
    //  this.achievmentitems.push({
    //    name: "",
    //    amount: "",
    //    fullfill: "",
    //  });
    //  const title = (
    //    <div>
    //      <h5>!دستاورد جدید افزوده شد</h5>
    //      <span>لطفا اطلاعات دستاورد جدید را در جدول مربوطه تکمیل کنید</span>
    //    </div>
    //  );
    //  this.toast(title, "info");
    //},
    addWorkshop() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.proposal.researcherWorkshops.push({
        workshopSubject: "",
        workshopPlace: "",
        workshopDate: "",
        workshopSupporterOrg: "",
      });
      const title = (
        <div>
          <h5>!دستاورد جدید افزوده شد</h5>
          <span>لطفا اطلاعات دستاورد جدید را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    addOrganizer() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.proposal.colleagues.push({
        name: "",
        lastName: "",
        cooperationType: "",
        position: "",
        mobile: "",
        email: "",
      });
      const title = (
        <div>
          <h5>!برگزار کننده جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات برگزار کننده جدید را در جدول مربوطه تکمیل کنید
          </span>
        </div>
      );
      this.toast(title, "info");
    },
    addMeeting() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.proposal.researcherMeetings.push({
        meetingSubject: "",
        meetingPlace: "",
        meetingDate: "",
        supporterOrg: "",
      });
      const title = (
        <div>
          <h5>!نشست جدید افزوده شد</h5>
          <span>لطفا اطلاعات نشست جدید را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    delMeeting(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      this.proposal.researcherMeetings.splice(order, 1);
    },
    delOrganizer(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      if (this.proposal.colleagues.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک فیلد باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.proposal.colleagues.splice(order, 1);
      }
    },
    delWorkshop(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      this.proposal.researcherWorkshops.splice(order, 1);
    },
    delAchievment(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      if (this.achievmentitems.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک فیلد باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.achievmentitems.splice(order, 1);
      }
    },
    addService() {
      // NOTE (m-addService) to add service costs in the relevant sections
      this.proposal.gantData.push({
        description: "",
        percent: 0,
        startDate: moment(new Date()).format("jYYYY/jMM/jDD"),
        dueDate: moment(new Date()).add(1, "day").format("jYYYY/jMM/jDD"),
        cellColor: "blue",
      });
      const title = (
        <div>
          <h5>!فاز جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هر فاز را در جدول مربوطه تکمیل کنید و به منظور
            بروزرسانی گانت چارت روی دکمه بروزرسانی کلیک کنید
          </span>
        </div>
      );
      this.toast(title, "info");
      this.myshow = !this.myshow;
    },
    delService(order) {
      // NOTE (m-delService) to remove services in the relevant sections
      this.proposal.gantData.splice(order, 1);
    },
    computedMaxDate(dueDate) {
      // REVIEW (m-computedMaxDate)
      let m = moment(dueDate, "jYYYY/jM/jD");
      m.subtract(1, "day");

      return m.format("jYYYY/jM/jDD");
    },
    computedMinDate(startDate) {
      // REVIEW (m-computedMinDate)
      let m = moment(startDate, "jYYYY/jM/jD");
      m.add(1, "day");

      return m.format("jYYYY/jM/jDD");
    },
    onMounted() {
      this.uploadedFiles = JSON.parse(JSON.stringify(this.uploadedFiles));
      this.files = JSON.parse(JSON.stringify(this.files));
      let acc = 0;
      // NOTE (MOUNTED) to show the profile of user
      this.$bvModal.show("loading");
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });

          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");

              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.$http
        .post(
          this.baseUrl + "/setad/admin/researchers/select",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.researchers = res.data.map((x) => {
            return {
              id: x.id,
              text: x.name,
            };
          });

          this.researchers.unshift({
            id: 0,
            text: "--پژوهشگر مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          this.$bvModal.hide("loading");
          this.isLoaded = true;
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
        });
      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              try {
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch (error) {
                console.log(error);
              }
            } catch {}
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStatesAndCities() {
      this.$http
        .get(
          this.baseUrl + "/setad/public/states/list",
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    // NOTE unuversity class if the university was "سایر"
    universityClass() {
      if (this.proposal.researcherUniversityId == this.notUniversity) {
        if (this.proposal.researcherUniversityOther) {
          return "done";
        } else {
          return "required";
        }
      } else {
        if (this.proposal.researcherUniversityId) {
          return "done";
        } else {
          return "required";
        }
      }
    },
    universityJobClass() {
      if (this.proposal.researcherUniversityJobId == this.notUniversity) {
        if (this.proposal.researcherUniversityJobOther) {
          return "done";
        } else {
          return "required";
        }
      } else {
        if (this.proposal.researcherUniversityJobId) {
          return "done";
        } else {
          return "required";
        }
      }
    },
    mehvarr() {
      let mehvarrr;
      try {
        mehvarrr = this.mehvars.filter((x) => x.id == this.proposal.mehvarId)[0]
          .text;
      } catch (error) {
        mehvarrr = "";
      }
      return mehvarrr;
    },
    computedMehvars() {
      // NOTE (c-computedMehvars) to after selecting university show to user list of mehvars of selected university
      let mehvarha = [];
      if (this.proposal.universityId) {
        mehvarha = this.mehvars.filter(
          (x) => x.universityId == this.proposal.universityId
        );
        if (this.proposal.universityId != this.notUniversity) {
          this.proposal.mehvarId = this.proposal.mehvarId;
        } else if (this.proposal.universityId == this.notUniversity) {
          this.proposal.mehvarId = this.notMehvar;
        }
      }
      if (this.proposal.universityId) {
        mehvarha.push(
          new Object({
            id: this.notMehvar,
            text: "سایر محورها",
            universityId: this.proposal.universityId,
          })
        );
      } else {
        mehvarha.push(
          new Object({
            id: 0,
            text: "لطفا ابتدا یک دانشگاه انتخاب کنید",
            universityId: this.proposal.universityId,
          })
        );
      }
      if (this.proposal.mehvarId)
        this.selectedMehvar = mehvarha.findIndex(
          (x) => x.id == this.proposal.mehvarId
        );
      else this.selectedMehvar = "-";
      // alert(mehvarha.map(y=>y.id))
      // this.proposal.mehvarId ? this.selectedMehvar = mehvarha.map(y=>y.id).findIndexOf(this.proposal.mehvarId) : this.selectedMehvar = ''
      return mehvarha;
    },
  },
  mounted() {
    this.getStatesAndCities();
    this.onMounted();
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
  },
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
